module.exports = __webpack_public_path__ + "static/media/WCCE-logo-grey.32876f2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/WCCE-logo-grey.svg
// module id = 305
// module chunks = 0